import { type Component, For } from "solid-js";
import { Skeleton } from "@/components/ui/skeleton";

export const TodoListSkeleton: Component = () => (
  <div
    class="opacity-0 will-change-[opacity]"
    style={{
      animation: "fade-in 600ms cubic-bezier(0.4, 0, 0.2, 1) forwards",
    }}
  >
    <div class="flex flex-col gap-2.5 w-full animate-pulse">
      <For each={Array.from({ length: 5 })}>
        {() => (
          <div class="flex items-center gap-4 px-4 py-3.5 rounded-xl border border-border/40 bg-card/30 backdrop-blur-[2px]">
            <Skeleton class="h-5 w-5 rounded-full shrink-0 bg-muted/60" />
            <div class="flex-1 space-y-2">
              <Skeleton class="h-4 w-[60%] rounded bg-muted/50" />
              <Skeleton class="h-3 w-[30%] rounded bg-muted/30" />
            </div>
            <Skeleton class="h-4 w-4 rounded shrink-0 bg-muted/40" />
          </div>
        )}
      </For>
    </div>
  </div>
);
